import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "inventory-delivery",
  "use": "inventory-delivery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"inventory-delivery\"><path d=\"M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2Zm-1 18H5V9h14v11Zm1-13H4V4h16v3Z\" fill=\"#003595\" /><path d=\"M15 12H9v2h6v-2Z\" fill=\"#003595\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol